export const getters = {
  getTeams($state) {
    return Object.values($state.records).sort((a, b) => {
      const nameA = a.name || '';
      const nameB = b.name || '';
      return nameA.localeCompare(nameB, 'pt-BR', { sensitivity: 'base' });
    });
  },
  getMyTeams($state, $getters) {
    return $getters.getTeams.filter(team => {
      const { is_member: isMember } = team;
      return isMember;
    });
  },
  getSupervisedTeamIds($state, $getters, rootState, rootGetters) {
    const currentUser = rootGetters.getCurrentUser;
    return $getters.getTeams
      .filter(team => team.supervisor_id === currentUser.id)
      .map(team => team.id);
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getTeam: $state => id => {
    const team = $state.records[id];
    return team || {};
  },
};
